/* eslint-disable @typescript-eslint/no-unused-expressions */
import { EllipsisOutlined } from '@ant-design/icons';
import {
  Row,
  Checkbox,
  message,
  Tag,
  PaginationProps,
  Col,
  Input,
  Table,
  Empty,
  Popover,
  List,
  Typography,
  Tooltip,
} from 'antd';
// import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ProfileIcon from '../../Components/ProfileIcon/profile.icon';
import { useConnection } from '../../Context/ConnectionContext/connectionContext';
import {
  addCommSepRound,
  addSpaces,
  CompanyRole,
  CreditTransferStage,
  getCompanyBgColor,
  getStageTransferEnumVal,
  getTransferStageTagType,
} from '../../Definitions/InterfacesAndType/programme.definitions';
import './programmeTransferManagement.scss';
import './creditTransfer.scss';
import '../Common/common.table.scss';
import { useUserContext } from '../../Context/UserInformationContext/userInformationContext';
import TransferActionModel from '../../Components/Models/TransferActionModel';
import { ProgrammeTransfer } from '@undp/carbon-library';
import * as Icon from 'react-bootstrap-icons';
import { TooltipColor } from '../Common/role.color.constants';
import { creditUnit } from '../Common/configs';
import { CircleFlag } from 'react-circle-flags';
import { Role } from '../../Casl/enums/role.enum';
import { ConfigurationSettingsType } from '../../Definitions/InterfacesAndType/settings.definitions';
import { useSettingsContext } from '../../Context/SettingsContext/settingsContext';
import { PauseCircle, PlayCircle } from 'react-bootstrap-icons';

type PopupInfo = {
  title: string;
  icon: any;
  actionBtnText: string;
  okAction: any;
  type: 'primary' | 'danger';
  remarkRequired: boolean;
};

const CreditTransfer = () => {
  const navigate = useNavigate();
  const { userInfoState } = useUserContext();
  const { i18n, t } = useTranslation(['common', 'creditTransfer', 'programme']);

  const statusOptions = Object.keys(CreditTransferStage).map((k, index) => ({
    label: addSpaces(Object.values(CreditTransferStage)[index]),
    value: k,
  }));

  const [selectedStatus, setSelectedStatus] = useState<any>(statusOptions.map((e) => e.value));
  const [selectedRetired, setSelectedRetired] = useState(true);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(true);

  const { post } = useConnection();
  const [totalProgramme, setTotalProgramme] = useState<number>();
  const [dataFilter, setDataFilter] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(50);
  const [search, setSearch] = useState<string>();
  const [searchText, setSearchText] = useState<string>();
  const [statusFilter, setStatusFilter] = useState<any>();
  const [sortOrder, setSortOrder] = useState<string>();
  const [sortField, setSortField] = useState<string>();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [selectedReq, setSelectedReq] = useState<ProgrammeTransfer>();
  const [popupInfo, setPopupInfo] = useState<PopupInfo>();
  const { isTransferFrozen, setTransferFrozen } = useSettingsContext();

  const onStatusQuery = async (checkedValues: CheckboxValueType[]) => {
    console.log(checkedValues);

    if (checkedValues !== selectedStatus) {
      setSelectedStatus(checkedValues);
    }

    if (checkedValues.length === 0) {
      setTableData([]);
      setTotalProgramme(0);
      return;
    }
    setStatusFilter({
      key: 'status',
      operation: 'in',
      value: checkedValues,
    });
  };
  const { Search } = Input;

  const onCheckAllChange = async (e: any) => {
    const isChecked = e.target.checked;
    const nw = isChecked ? statusOptions.map((el) => el.value) : [];
    setSelectedRetired(isChecked);
    setSelectedStatus(nw);
    setIndeterminate(false);
    setCheckAll(isChecked);
    await onStatusQuery(nw);
  };

  const getAllTransfers = async () => {
    setLoading(true);
    const filter: any[] = [];
    if (statusFilter) {
      filter.push(statusFilter);
    }
    filter.push({
      key: 'isRetirement',
      operation: '=',
      value: selectedRetired,
    });

    if (search && search !== '') {
      const interFilterOr = [
        {
          key: 'programmeTitle',
          operation: 'like',
          value: `${search}%`,
        },
      ];
      if (!isNaN(Number(search))) {
        interFilterOr.push({
          key: 'requestId',
          operation: '=',
          value: `${search}`,
        });
      }
      filter.push({
        value: {
          page: currentPage,
          size: pageSize,
          filterOr: interFilterOr,
        },
      });
    }

    let sort: any;
    if (sortOrder && sortField) {
      sort = {
        key: sortField === 'programmeCertifierId' ? 'programmeCertifierId[1]' : sortField,
        order: sortOrder,
        nullFirst: false,
      };
    } else {
      sort = {
        key: 'requestId',
        order: 'DESC',
      };
    }

    try {
      const response: any = await post('national/programme/transferQuery', {
        page: currentPage,
        size: pageSize,
        filterAnd: filter,
        filterOr: dataFilter,
        sort: sort,
      });
      console.log(response);

      if (userInfoState?.companyRole !== 'Government') {
        const filteredData = (response.data || []).filter((item: any) =>
          item.companyId.includes(userInfoState?.companyId + '')
        );
        setTableData(filteredData);
        setTotalProgramme(filteredData.length);
      } else {
        setTableData(response.data);
        setTotalProgramme(response.response.data.total);
      }

      setLoading(false);
    } catch (error: any) {
      console.log('Error in getting programme transfers', error);
      message.open({
        type: 'error',
        content: error.message,
        duration: 3,
        style: { textAlign: 'right', marginRight: 15, marginTop: 10 },
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getAllTransfers();
    }
  }, [statusFilter, dataFilter]);

  useEffect(() => {
    getAllTransfers();
  }, [currentPage, pageSize, sortField, sortOrder, search]);

  const handleRequestOk = async (
    reqId: number,
    remarks: string,
    endpoint: string,
    successText?: string,
    isRetire?: boolean
  ) => {
    setLoading(true);
    try {
      const response: any = await post('national/programme/' + endpoint, {
        requestId: reqId,
        comment: remarks,
      });
      let successMsg = response.message;
      if (isRetire) {
        successMsg = t('creditTransfer:internationalTransferReqCancelled');
      }
      console.log(response);
      message.open({
        type: 'success',
        content: successText ?? successMsg,
        duration: 3,
        style: { textAlign: 'right', marginRight: 15, marginTop: 10 },
      });
      setLoading(false);
      getAllTransfers();
      setModalVisible(false);
    } catch (error: any) {
      console.log('Error in Cancelling transfer request', error);
      setLoading(false);
      return error.message;
    }
  };

  const showModalOnAction = (record: any, info: PopupInfo) => {
    setSelectedReq(record);
    setModalVisible(true);
    setPopupInfo(info);
  };

  const getSendCreditBalance = (record: ProgrammeTransfer) => {
    const idx = record.companyId!.map((e) => Number(e)).indexOf(record.fromCompanyId!);
    if (idx < 0) {
      return 0;
    }
    if (!record.creditOwnerPercentage) {
      return record.creditBalance;
    }
    return (Number(record.creditBalance!) * Number(record.creditOwnerPercentage![idx])) / 100;
  };

  const actionMenu = (record: any) => {
    let isRetire = false;
    if (record.isRetirement === true) {
      isRetire = true;
    }
    if (record.status === 'Pending' && userInfoState?.userRole !== Role.ViewOnly) {
      return userInfoState?.companyId === record.initiatorCompanyId ? (
        <List
          className="action-menu"
          size="small"
          dataSource={[
            {
              text: t('creditTransfer:cancel'),
              icon: <Icon.ExclamationOctagon />,
              click: () => {
                showModalOnAction(record, {
                  title: t('creditTransfer:cancelTitle'),
                  icon: <Icon.ExclamationOctagon />,
                  actionBtnText: t('creditTransfer:proceed'),
                  okAction: (requestId: any, comment: any) =>
                    handleRequestOk(requestId, comment, 'transferCancel', undefined, isRetire),
                  type: 'danger',
                  remarkRequired: true,
                });
              },
            },
          ]}
          renderItem={(item: any) => (
            <List.Item onClick={item.click}>
              <Typography.Text className="action-icon color-error">{item.icon}</Typography.Text>
              <span>{item.text}</span>
            </List.Item>
          )}
        />
      ) : !record.isRetirement && record.fromCompanyId === userInfoState?.companyId ? (
        <List
          className="action-menu"
          size="small"
          dataSource={[
            {
              text: t('creditTransfer:accept'),
              icon: <Icon.ClipboardCheck />,
              style: 'color-primary',
              click: () => {
                showModalOnAction(record, {
                  title: t('creditTransfer:acceptTitle'),
                  icon: <Icon.ClipboardCheck />,
                  actionBtnText: t('creditTransfer:proceed'),
                  okAction: (requestId: any, comment: any) =>
                    handleRequestOk(
                      requestId,
                      comment,
                      'transferApprove',
                      `${t('creditTransfer:transferReqApproved')}`
                    ),
                  type: 'primary',
                  remarkRequired: false,
                });
              },
            },
            {
              text: t('creditTransfer:reject'),
              icon: <Icon.XOctagon />,
              style: 'color-error',
              click: () => {
                showModalOnAction(record, {
                  title: t('creditTransfer:rejectTitle'),
                  icon: <Icon.XOctagon />,
                  actionBtnText: t('creditTransfer:reject'),
                  okAction: (requestId: any, comment: any) =>
                    handleRequestOk(requestId, comment, 'transferReject'),
                  type: 'danger',
                  remarkRequired: true,
                });
              },
            },
          ]}
          renderItem={(item: any) => (
            <List.Item onClick={item.click}>
              <Typography.Text className={`action-icon ${item.style}`}>{item.icon}</Typography.Text>
              <span>{item.text}</span>
            </List.Item>
          )}
        />
      ) : record.isRetirement && userInfoState?.companyRole === CompanyRole.GOVERNMENT ? (
        <List
          className="action-menu"
          size="small"
          dataSource={[
            {
              text: t('creditTransfer:recognise'),
              icon: <Icon.Save />,
              style: 'color-primary',
              click: () => {
                showModalOnAction(record, {
                  title: t('creditTransfer:recogniseTitle'),
                  icon: <Icon.Save />,
                  actionBtnText: t('creditTransfer:recognise'),
                  okAction: (requestId: any, comment: any) =>
                    handleRequestOk(
                      requestId,
                      comment,
                      'transferApprove',
                      `${t('creditTransfer:internationalTranferReqAccepted')}`
                    ),
                  type: 'primary',
                  remarkRequired: false,
                });
              },
            },
            {
              text: t('creditTransfer:notrecognise'),
              icon: <Icon.XOctagon />,
              style: 'color-error',
              click: () => {
                showModalOnAction(record, {
                  title: t('creditTransfer:notRecogniseTitle'),
                  icon: <Icon.XOctagon />,
                  actionBtnText: t('creditTransfer:notrecognise'),
                  okAction: (requestId: any, comment: any) =>
                    handleRequestOk(
                      requestId,
                      comment,
                      'transferReject',
                      `${t('creditTransfer:internationalTranferReqAccepted')}`
                    ),
                  type: 'danger',
                  remarkRequired: true,
                });
              },
            },
          ]}
          renderItem={(item: any) => (
            <List.Item onClick={item.click}>
              <Typography.Text className={`action-icon ${item.style}`}>{item.icon}</Typography.Text>
              <span>{item.text}</span>
            </List.Item>
          )}
        />
      ) : null;
    }
  };

  const columns = [
    {
      title: t('creditTransfer:requestID'),
      dataIndex: 'requestId',
      key: 'requestId',
      sorter: true,
    },
    {
      title: t('creditTransfer:date'),
      key: 'txTime',
      sorter: true,
      align: 'left' as const,
      render: (item: any, itemObj: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {DateTime.fromMillis(parseInt(itemObj.txTime)).toFormat('dd LLLL yyyy')}
          </div>
        );
      },
    },
    {
      title: t('creditTransfer:pName'),
      dataIndex: 'programmeTitle',
      key: 'programmeTitle',
      sorter: true,
      align: 'left' as const,
      render: (item: any) => {
        return <span className="clickable">{item}</span>;
      },
      onCell: (record: any, rowIndex: any) => {
        return {
          onClick: (ev: any) => {
            navigate('/programmeManagement/view', { state: { id: record.programmeId } });
          },
        };
      },
    },
    {
      title: t('creditTransfer:sector'),
      dataIndex: 'programmeSector',
      key: 'programmeSector',
      sorter: true,
      align: 'left' as const,
    },
    {
      title: t('creditTransfer:certifier'),
      dataIndex: 'programmeCertifierId',
      key: 'programmeCertifierId',
      sorter: true,
      align: 'left' as const,
      render: (item: any, itemObj: any) => {
        if (item === null) {
          return;
        }
        const cMap: any = {};
        for (const c of itemObj.certifier) {
          cMap[c.companyId] = c;
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {itemObj.programmeCertifierId &&
              itemObj.programmeCertifierId.map((id: any, i: any) => {
                const v = cMap[id];
                if (!v) {
                  return;
                }
                return (
                  <Tooltip title={v.name} color={TooltipColor} key={TooltipColor}>
                    <div>
                      <ProfileIcon icon={v.logo} bg="rgba(128, 255, 0, 0.12)" name={v.name} />
                    </div>
                  </Tooltip>
                );
              })}
          </div>
        );
      },
    },
    {
      title: t('creditTransfer:initiator'),
      key: 'initiatorCompanyId',
      sorter: true,
      align: 'left' as const,
      render: (item: any, itemObj: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {itemObj.requester &&
              itemObj.requester.map((v: any, i: any) => {
                return (
                  <Tooltip title={v.name} color={TooltipColor} key={TooltipColor}>
                    <div>
                      <ProfileIcon
                        icon={v.logo}
                        bg={getCompanyBgColor(v.companyRole)}
                        name={v.name}
                      />
                    </div>
                  </Tooltip>
                );
              })}
          </div>
        );
      },
    },
    {
      title: t('creditTransfer:cSender'),
      key: 'fromCompanyId',
      sorter: true,
      align: 'left' as const,
      render: (item: any, itemObj: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {itemObj.sender &&
              itemObj.sender.map((v: any, i: any) => {
                return (
                  <Tooltip title={v.name} color={TooltipColor} key={TooltipColor}>
                    <div>
                      <ProfileIcon
                        icon={v.logo}
                        bg={getCompanyBgColor(v.companyRole)}
                        name={v.name}
                      />
                    </div>
                  </Tooltip>
                );
              })}
          </div>
        );
      },
    },
    {
      title: t('creditTransfer:cReceiver'),
      dataIndex: 'toCompanyId',
      key: 'toCompanyId',
      sorter: true,
      align: 'left' as const,
      render: (item: any, itemObj: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {itemObj.receiver &&
              itemObj.receiver.map((v: any, i: any) => {
                return !itemObj.isRetirement ? (
                  <Tooltip title={v.name} color={TooltipColor} key={TooltipColor}>
                    <div>
                      <ProfileIcon
                        icon={v.logo}
                        bg={getCompanyBgColor(v.companyRole)}
                        name={v.name}
                      />
                    </div>
                  </Tooltip>
                ) : itemObj.retirementType === '0' ? (
                  <Tooltip
                    title={
                      t('creditTransfer:iaccount') +
                      `${
                        itemObj.toCompanyMeta && itemObj.toCompanyMeta.countryName
                          ? ' - ' + itemObj.toCompanyMeta.countryName
                          : ''
                      }`
                    }
                    color={TooltipColor}
                    key={TooltipColor}
                  >
                    {itemObj.toCompanyMeta && itemObj.toCompanyMeta.country && (
                      <CircleFlag
                        className="profile-icon flag-ret-icon"
                        countryCode={itemObj.toCompanyMeta.country.toLowerCase()}
                      />
                    )}
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={t('creditTransfer:laccount')}
                    color={TooltipColor}
                    key={TooltipColor}
                  >
                    <div className="ret-icon profile-icon">
                      <Icon.Save />
                    </div>
                  </Tooltip>
                );
              })}
          </div>
        );
      },
    },
    {
      title: t('creditTransfer:cRequested') + ` (${creditUnit})`,
      dataIndex: 'creditAmount',
      key: 'creditAmount',
      sorter: true,
      align: 'right' as const,
      render: (item: any) => {
        return <span className="clickable">{addCommSepRound(item)}</span>;
      },
    },
    // {
    //   title: t('creditTransfer:cBalance') + ` (${creditUnit})`,
    //   dataIndex: 'creditBalance',
    //   key: 'creditBalance',
    //   sorter: true,
    //   align: 'right' as const,
    //   render: (item: any, Obj: any) => {
    //     return <span>{addCommSepRound(getSendCreditBalance(Obj))}</span>;
    //   },
    // },
    {
      title: t('programme:status'),
      key: 'status',
      sorter: true,
      align: 'center' as const,
      render: (item: any, Obj: any) => {
        return (
          <Tooltip title={Obj.serialNo} color={TooltipColor} key={TooltipColor}>
            <Tag className="clickable" color={getTransferStageTagType(Obj.status, Obj)}>
              {addSpaces(getStageTransferEnumVal(Obj.status, Obj))}
            </Tag>
          </Tooltip>
        );
      },
    },
    {
      align: 'right' as const,
      render: (_: any, record: any) => {
        const menu = actionMenu(record);
        return menu && !isTransferFrozen ? (
          <Popover placement="bottomRight" content={menu} trigger="click">
            <EllipsisOutlined
              rotate={90}
              style={{ fontWeight: 600, fontSize: '1rem', cursor: 'pointer' }}
            />
          </Popover>
        ) : (
          <span></span>
        );
      },
      // render: () => {
      //   return (
      //     <div className="clickable">
      //       <MoreOutlined style={{ fontSize: '20px' }} />
      //     </div>
      //   );
      // },
    },
  ];

  const onSearch = async () => {
    setSearch(searchText);
  };

  const onChange: PaginationProps['onChange'] = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const handleTableChange = (pag: any, sorter: any) => {
    console.log(pag, sorter);
    setSortOrder(
      sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : undefined
    );
    setSortField(sorter.columnKey);
    // setCurrentPage(1);
  };

  const onFreezeTransfer = async () => {
    const response = await post('national/Settings/update', {
      id: ConfigurationSettingsType.isTransferFrozen,
      settingValue: `${!isTransferFrozen}`,
    });
    if (response) {
      setTransferFrozen(!isTransferFrozen);
    }
  };

  return (
    <div className="credit-transfer-management content-container">
      <div className="title-bar">
        <Row justify="space-between" align="middle">
          <Col span={20}>
            <div className="body-title">{'Accounts'}</div>
            <div className="body-sub-title">{t('creditTransfer:desc')}</div>
          </Col>
          <Col span={4}>
            {((userInfoState?.companyRole === CompanyRole.GOVERNMENT &&
              userInfoState?.userRole === Role.Admin) ||
              userInfoState?.userRole === Role.Root) && (
              <div className="transfer-freeze-icon" onClick={onFreezeTransfer}>
                {isTransferFrozen ? (
                  <PlayCircle className="play-circle" size={35}></PlayCircle>
                ) : (
                  <PauseCircle className="pause-circle" size={35}></PauseCircle>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
      <div className="content-card">
        <Row>
          <Col lg={{ span: 16 }} md={{ span: 16 }}>
            <div className="action-bar">
              <Checkbox
                className="all-check"
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
                defaultChecked={true}
              >
                All
              </Checkbox>
              <Checkbox.Group
                options={statusOptions}
                defaultValue={statusOptions.map((e) => e.value)}
                value={selectedStatus}
                onChange={onStatusQuery}
              />
              <Checkbox
                onChange={async (e) => {
                  setSelectedRetired(e.target.checked);
                  if (!e.target.checked && checkAll) {
                    setCheckAll(false);
                  } else if (e.target.checked && selectedStatus.length === statusOptions.length) {
                    setCheckAll(true);
                  }
                  await getAllTransfers();
                }}
                checked={selectedRetired}
              >
                Retired
              </Checkbox>
            </div>
          </Col>
          <Col lg={{ span: 8 }} md={{ span: 8 }}>
            <div className="filter-section">
              <div className="search-filter">
                <Checkbox
                  className="label"
                  onChange={(v) =>
                    setDataFilter(
                      v.target.checked
                        ? [
                            {
                              key: 'initiatorCompanyId',
                              operation: '=',
                              value: userInfoState?.companyId,
                            },
                            {
                              key: 'fromCompanyId',
                              operation: '=',
                              value: userInfoState?.companyId,
                            },
                            {
                              key: 'toCompanyId',
                              operation: '=',
                              value: userInfoState?.companyId,
                            },
                            {
                              key: 'programmeCertifierId',
                              operation: 'ANY',
                              value: userInfoState?.companyId,
                            },
                          ]
                        : undefined
                    )
                  }
                >
                  {t('view:seeMine')}
                </Checkbox>
              </div>
              <div className="search-bar">
                <Search
                  onPressEnter={onSearch}
                  placeholder={'Search'}
                  allowClear
                  onChange={(e) =>
                    e.target.value === ''
                      ? setSearch(e.target.value)
                      : setSearchText(e.target.value)
                  }
                  onSearch={setSearch}
                  style={{ width: 265 }}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="programmeManagement-table-container">
              <Table
                dataSource={tableData}
                columns={columns}
                className="common-table-class"
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: totalProgramme,
                  showQuickJumper: true,
                  showSizeChanger: true,
                  onChange: onChange,
                }}
                onChange={(val: any, filter: any, sorter: any) => handleTableChange(val, sorter)}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={tableData.length === 0 ? t('creditTransfer:noTransfer') : null}
                    />
                  ),
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
      {popupInfo && selectedReq && (
        <TransferActionModel
          transfer={selectedReq!}
          onCancel={() => {
            setModalVisible(false);
            setSelectedReq(undefined);
          }}
          actionBtnText={popupInfo!.actionBtnText}
          onFinish={popupInfo?.okAction}
          subText={''}
          openModal={modalVisible}
          icon={popupInfo!.icon}
          title={popupInfo!.title}
          type={popupInfo!.type}
          remarkRequired={popupInfo.remarkRequired}
        />
      )}
      {/* <Modal
        centered
        title=""
        okText="REJECT"
        open={rejectModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <div className="credit-transfer-modal-container">
          <div className="icon-credit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100"
              height="100"
              fill="currentColor"
              className="bi bi-envelope-slash"
              viewBox="0 0 16 16"
              color="#FF4C51"
            >
              <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
              <path d="M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z" />
            </svg>
          </div>
          <div className="credit-transfer-details">
            <div className="content-credit-transfer">
              Are you sure you want to reject this project?
            </div>
            <div className="sub-content-credit-transfer">You can’t undo this action</div>
          </div>
          <div className="remarks-credit-transfer">
            <Form
              name="modal-details"
              className="modal-form"
              layout={'vertical'}
              requiredMark={true}
              form={formModal}
              onFinish={handleOk}
            >
              <Row>
                <Col offset={1} span={22}>
                  <Form.Item
                    className="remarks-label"
                    label="Remarks"
                    name="remarks"
                    rules={[
                      {
                        required: true,
                        message: 'Remarks is required!',
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <div className="modal-credit-transfer-btns">
                  <div className="center width-60">
                    <Button onClick={handleCancel}>CANCEL</Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      REJECT
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
      <Modal
        centered
        title=""
        okText="CANCEL"
        open={cancelModalVisible}
        onOk={handleCancelOk}
        onCancel={handleCancelCancel}
        footer={null}
      >
        <div className="credit-transfer-modal-container">
          <div className="icon-credit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              color="#FF4C51"
              width="100"
              height="100"
              fill="currentColor"
              className="bi bi-clipboard-x"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"
              />
              <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
              <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
            </svg>
          </div>
          <div className="credit-transfer-details">
            <div className="content-credit-transfer">
              Are you sure you want to cancel this request?
            </div>
            <div className="sub-content-credit-transfer">You can’t undo this action</div>
          </div>
          <div className="remarks-credit-transfer">
            <Form
              name="modal-details"
              className="modal-form"
              layout={'vertical'}
              requiredMark={true}
              form={formModal}
              onFinish={handleCancelOk}
            >
              <Form.Item
                className="remarks-label"
                label="Remarks"
                name="remarks"
                rules={[
                  {
                    required: true,
                    message: 'Remarks is required!',
                  },
                ]}
              >
                <Input.TextArea placeholder="" />
              </Form.Item>
              <Form.Item>
                <div className="modal-credit-transfer-btns">
                  <div className="center width-60">
                    <Button onClick={handleCancelCancel}>CANCEL</Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      CANCEL
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
      <Modal
        centered
        title=""
        okText="APPROVE"
        open={acceptModalVisible}
        onOk={handleAcceptOk}
        onCancel={handleAcceptCancel}
        footer={null}
      >
        <div className="credit-transfer-modal-container">
          <div className="icon-credit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="140"
              height="140"
              fill="currentColor"
              className="bi bi-hand-thumbs-up"
              viewBox="0 0 16 16"
              color="#16B1FF"
            >
              <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
            </svg>
          </div>
          <div className="credit-transfer-details">
            <div className="content-credit-transfer">Accept Transfer Request</div>
          </div>
          <div className="remarks-credit-transfer">
            <Form
              name="modal-details"
              className="modal-form"
              layout={'vertical'}
              requiredMark={true}
              form={formModal}
              onFinish={handleAcceptOk}
            >
              {companiesInfo?.length !== 0 &&
                !loading &&
                companiesInfo?.map((v: any, i: any) => {
                  return (
                    <Row>
                      <Col offset={1} span={8}>
                        <Form.Item className="remarks-label" name="companyName">
                          {v.name}
                        </Form.Item>
                      </Col>
                      <Col offset={1} span={5}>
                        <Form.Item
                          className="remarks-label"
                          name={'credits' + i}
                          rules={[
                            {
                              pattern: new RegExp(/^[+]?([.]\d+|\d+[.]?\d*)$/g),
                              message: 'Credit Should be a positive number',
                            },
                            ({ getFieldValue }) => ({
                              validator(rule, value) {
                                if (getFieldValue('credits' + i) > v.credit) {
                                  // eslint-disable-next-line prefer-promise-reject-errors
                                  return Promise.reject(
                                    'Credit amount should not be greater than company credit'
                                  );
                                } else if (getFieldValue('credits' + i) > creditAmount) {
                                  // eslint-disable-next-line prefer-promise-reject-errors
                                  return Promise.reject(
                                    'Credit amount should not be greater than requested credit Amount'
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="" />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <div
                          style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                          }}
                        >
                          <span>/</span>
                        </div>
                      </Col>
                      <Col span={4}>
                        <Form.Item className="remarks-label" name="totalCredit">
                          <Input placeholder={v.credit} disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  );
                })}
              <Row>
                <Col offset={1} span={8}>
                  <Form.Item className="remarks-label" name="companyName">
                    Requested Amount
                  </Form.Item>
                </Col>
                <Col offset={1} span={5}>
                  <Form.Item className="remarks-label" name="totalRequest">
                    <Input placeholder={creditAmount.toString()} disabled />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <div
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    <span>/</span>
                  </div>
                </Col>
                <Col span={4}>
                  <Form.Item className="remarks-label" name="totalCredit">
                    <Input placeholder={parseInt(totalComCredits.toString()).toString()} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col offset={1} span={22}>
                  <Form.Item
                    className="remarks-label"
                    label="Remarks"
                    name="remarksApprove"
                    rules={[
                      {
                        required: true,
                        message: 'Remarks is required!',
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <div className="modal-credit-transfer-btns">
                  <div className="center width-60">
                    <Button onClick={handleAcceptCancel}>CANCEL</Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      ACCEPT
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal> */}
    </div>
  );
};

export default CreditTransfer;
